import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

//Estilos
import './Modal.css';

//Componentes

/**
 * Este componente se encarga de crear modales con titulo, body y un footer con botones
 * @component
 */
function Modal({ children, title, questionModal, isOpen, onClose }) {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="modal-background">
            <div className="modal-card">
                <header className="modal-header">
                    {title && <h3 className="modal-title">{title}</h3>}
                    <button className="modal-close_button" onClick={onClose}>
                        X
                    </button>
                </header>

                <div className="modal-body">{children}</div>
                {!questionModal && (
                    <div className="modal-footer">
                        <button
                            className="btn btn-primary"
                            title="Aceptar"
                            onClick={onClose}
                        >
                            Aceptar
                        </button>
                    </div>
                )}
            </div>
        </div>,
        document.getElementById('modal')
    );
}

export default Modal;

Modal.propTypes = {
    /**
     * Aca se pasan los elementos hijos que se renderizaran en el body del modal
     */
    children: PropTypes.any,

    /**
     * Titulo del modal
     */
    title: PropTypes.string,

    /**
     * Esta prop es para que se muestre el boton de cancelar, de lo contrario solo se muestra el de aceptar
     */
    questionModal: PropTypes.bool,

    /**
     * Booleano que controla la visualizacion del modal
     */
    isOpen: PropTypes.bool,

    /**
     * Funcion que controla el cerrado del modal
     */
    onClose: PropTypes.func,

    /**
     * Funcion que se ejecuta al darle click al boton de aceptar
     */
    onAccept: PropTypes.func,
};
